module.exports = __webpack_public_path__ + "img/mobile-download-android.6c23c7c3.webp";